module.exports = __webpack_public_path__ + "media/images/flags/4x3/bdi-36e260ce0df4a96bc6c976535172cb31.svg";